import { render, staticRenderFns } from "./bezopasnost.vue?vue&type=template&id=3684468a&scoped=true&"
import script from "./bezopasnost.vue?vue&type=script&lang=js&"
export * from "./bezopasnost.vue?vue&type=script&lang=js&"
import style0 from "./bezopasnost.vue?vue&type=style&index=0&id=3684468a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3684468a",
  null
  
)

export default component.exports